import BaseClient from './BaseClient';

class GroupUsersClient extends BaseClient {
    listGroupUsers(teamId, groupId, params) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/users`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    countGroupUsers(teamId, groupId, params) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/users/count`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    upsertGroupUser(teamId, groupId, userId, data) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/users/${userId}`;

        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteGroupUser(teamId, groupId, userId) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/users/${userId}`;

        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new GroupUsersClient();
